import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { usesDemoAvatars } from "../utils/personImage";

export default function Booth3D() {
  const [document, setDocument] = useState("");
  const [error, setError] = useState("");
  const allowed = usesDemoAvatars();
  const frame = useRef(null);
  const latest = useRef(null);

  useEffect(() => {
    if (!allowed) return;
    const controller = new AbortController();
    const send = message => frame.current?.contentWindow?.postMessage({ channel: "pixels-booth-live", ...message }, "*");
    const onMessage = event => {
      if (event.source !== frame.current?.contentWindow || event.data?.channel !== "pixels-booth-live" || event.data?.kind !== "ready") return;
      if (latest.current) send({ kind: "snapshot", data: latest.current });
    };
    window.addEventListener("message", onMessage);
    let busy = false;
    const poll = async () => {
      if (busy || controller.signal.aborted) return;
      busy = true;
      try {
        const response = await fetch("/api/booth/live", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, signal: controller.signal });
        if (!response.ok) throw new Error("โหลดข้อมูลสดไม่สำเร็จ");
        const data = await response.json();
        if (controller.signal.aborted) return;
        latest.current = data;
        send({ kind: "snapshot", data });
      } catch (error) {
        if (error.name !== "AbortError") send({ kind: "status", state: "error", msg: error.message });
      } finally { busy = false; }
    };
    poll();
    const interval = setInterval(poll, 3000);
    fetch("/api/booth/document", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      signal: controller.signal,
    }).then(async response => {
      if (!response.ok) throw new Error(response.status === 403 ? "บัญชีนี้ไม่มีสิทธิ์เปิดหน้านี้" : "โหลดหน้า Booth 3D ไม่สำเร็จ กรุณาลองใหม่");
      setDocument(await response.text());
    }).catch(error => {
      if (error.name !== "AbortError") setError(error.message);
    });
    return () => { controller.abort(); clearInterval(interval); window.removeEventListener("message", onMessage); };
  }, [allowed]);

  if (!allowed) return <Navigate to="/customer-flow" replace />;
  if (error) return <div className="p-8 text-center text-red-600">{error}<button onClick={() => window.location.reload()} className="ml-4 rounded-lg border px-3 py-2 text-slate-600">ลองใหม่</button></div>;
  if (!document) return <div className="p-8 text-center text-slate-500">กำลังโหลด PIXELS Booth 3D...</div>;
  return <iframe ref={frame} title="PIXELS Booth 3D" srcDoc={document} sandbox="allow-scripts allow-downloads" allow="fullscreen" className="block h-[calc(100dvh-4rem)] w-full border-0" />;
}
